import Lightbox from "./lightbox";

class Footer {
  stateClass = {
    dark: "footer--dark",
  };

  constructor($el) {
    this.$el = $el;
    this.$newsletterTrigger = this.$el.find('[data-newsletter="trigger"]');

    if (this.$newsletterTrigger.length) {
      this.lightbox = new Lightbox(this.$newsletterTrigger);
    }
  }

  handleFooterClass = (scope) => {
    const $last = $(scope).find("section").last();

    if ($last.hasClass("bg-dark")) {
      this.$el.addClass(this.stateClass.dark);
    } else {
      this.$el.removeClass(this.stateClass.dark);
    }
  };
}

export default Footer;
